import { useContext } from 'react'
import { Col, Form } from 'react-bootstrap'
import { PlayerContext } from '../../pages/Home'

const ProgressBar = () => {
  const { length, playTime, seekRecording } = useContext(PlayerContext)

  const getTime = (time) =>
    `${Math.floor(time / 60)}:${`0${Math.floor(time % 60)}`.slice(-2)}`

  return (
    <>
      <Col className='flex-grow-0 p-0'>
        {playTime === 0 ? '0:00' : getTime(playTime)}
      </Col>
      <Col className='flex-grow-1 align-self-center'>
        <Form.Range
          className='player-progress'
          min={0}
          max={length}
          value={playTime}
          onInput={seekRecording}
        />
      </Col>
      <Col className='flex-grow-0 p-0'>
        {length === 0 ? '0:00' : getTime(length)}
      </Col>
    </>
  )
}
export default ProgressBar
